var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge",class:_vm.classObject,on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }